export default __webpack_public_path__ + "static/media/Avatar-19-noback.e1019c55.png";